module.exports = __webpack_public_path__ + "assets/img/shop-dice.fb224d78.png";